import { Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';

import type { Station } from '@/modules/api/backend';

interface StationDetailCardTableProps {
  station: Station;
}

export function StationDetailTable({ station }: StationDetailCardTableProps) {
  const rows: { label: string; value?: string }[] = [
    { label: 'Hinweis', value: station.stationComment ?? undefined },
    {
      label: 'Anzahl der B+R Anlagen',
      value: station.numBrFacility != null ? String(station.numBrFacility) : undefined,
    },
  ];

  const visibleRows = rows.filter((row) => !!row.value);

  return (
    <TableContainer>
      <Table>
        <TableBody>
          {visibleRows.map((row) => (
            <TableRow key={row.label}>
              <TableCell sx={{ wordBreak: 'break-word', hyphens: 'auto', width: 120 }}>
                <Typography lang="de" variant="caption">
                  {row.label}
                </Typography>
              </TableCell>
              <TableCell sx={{ whiteSpace: 'pre-line' }}>
                <Typography variant="body2">{row.value}</Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
